module.exports = __webpack_public_path__ + "static/dot_grid-36bcaceb036b3067f20b876ef471e085.png";